var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { WMLogger } from '@mobilize/logging';
import { Constants, ContentType, Events } from '../Contract';
import { Response } from '../Server';
import { Exception, ExceptionHandler, NetworkException } from '../System';
import { Inject, PendingEvent } from './';
export var ActionState;
(function (ActionState) {
    ActionState[ActionState["Sending"] = 0] = "Sending";
    ActionState[ActionState["Idle"] = 1] = "Idle";
})(ActionState || (ActionState = {}));
var ActionService = (function () {
    function ActionService(inject) {
        if (inject === void 0) { inject = null; }
        var _this = this;
        this.inject = inject || Inject.Instance;
        this.http = this.inject.resolve(Constants.Server);
        this.urlResolver = this.inject.resolve(Constants.UrlResolver);
        this.changeBuffer = this.inject.resolve(Constants.NotifyBuffer);
        this.pendingEvents = new Array();
        this.event = this.inject.resolve(Constants.EventAggregator);
        this.state = ActionState.Idle;
        this.requestBuilder = this.inject.resolve(Constants.RequestBuilder);
        this.commandGenerators = [];
        if (this.event) {
            this.event.subscribe(Events.PreActionCommandGeneratorRegistration, function (generator) {
                _this.addCommandGenerator(generator);
            });
            this.event.subscribe(Events.PreActionCommandGeneratorDeregistration, function (generator) {
                _this.removeCommandGenerator(generator);
            });
            this.event.subscribe(Events.DeletePendingActions, function (id) {
                _this.deletePendingEvents(id);
            });
        }
    }
    ActionService.prototype.send = function (action, includeDirty) {
        var request = this.requestBuilder.create(action);
        if (action.requestConfig.includeDirty) {
            request.dirty = this.changeBuffer.getChanges();
        }
        if (request.commands) {
            request.commands = this.buildCommandGenerators().map(function (c) {
                delete c.receiverId;
                return c;
            });
        }
        if (action.highPriority) {
            this.pendingEvents.unshift(new PendingEvent(action, request));
        }
        else {
            this.pendingEvents.push(new PendingEvent(action, request));
        }
        this.sendActions();
    };
    ActionService.prototype.sendImmediateAction = function (action, includeDirty) { };
    ActionService.prototype.getEvents = function () {
        return this.pendingEvents;
    };
    ActionService.prototype.addCommandGenerator = function (commandGenerator) {
        if (this.commandGenerators.indexOf(commandGenerator) === -1) {
            this.commandGenerators.push(commandGenerator);
        }
    };
    ActionService.prototype.removeCommandGenerator = function (commandGenerator) {
        var index = this.commandGenerators.indexOf(commandGenerator);
        if (index !== -1) {
            this.commandGenerators.splice(index, 1);
            this.commandGenerators[index] = this.commandGenerators[this.commandGenerators.length - 1];
            this.commandGenerators.pop();
        }
    };
    ActionService.prototype.sendActions = function () {
        var _this = this;
        if (this.state === ActionState.Idle) {
            this.state = ActionState.Sending;
            var event_1 = this.pendingEvents.shift();
            var data = void 0;
            switch (event_1.action.requestConfig.contentType) {
                case ContentType.multipartFormdata:
                    data = event_1.request;
                    break;
                case ContentType.applicationJson:
                    data = JSON.stringify(event_1.request);
                    break;
                default:
                    data = JSON.stringify(event_1.request);
                    break;
            }
            this.http.post(this.urlResolver.resolveUrl(event_1.action), data, function (response) { _this.handleResponse(event_1.action, response); }, event_1.action.requestConfig);
        }
    };
    ActionService.prototype.handleResponse = function (action, response) {
        if ((response === undefined) || response.status && response.status !== 200) {
            this.event.publish(Events.Error, new NetworkException(response.responseText, response.status));
            this.processCallbacks(action, new Response(response));
            WMLogger.instance().error('The response is undefined or with a wrong status');
        }
        else if (response.ErrorOcurred) {
            this.event.publish(Events.Error, new Exception("".concat(response.ExMessage, "\n").concat(response.ExStackTrace)));
            this.state = ActionState.Idle;
            WMLogger.instance().error('An error ocurred processing the request');
        }
        else {
            this.processActionResponse(action, new Response(response));
        }
    };
    ActionService.prototype.buildCommandGenerators = function () {
        if (this.commandGenerators.length === 0) {
            return [];
        }
        return this.commandGenerators.map(function (c) { return c(); }).filter(function (command) { return command != null; });
    };
    ActionService.prototype.deletePendingEvents = function (ids) {
        if (this.pendingEvents && ids && ids.length > 0) {
            this.pendingEvents = this.pendingEvents.filter(function (pending) { return ids.indexOf(pending.action.receiverId) === -1; });
        }
    };
    ActionService.prototype.processActionResponse = function (action, response) {
        this.event.publish(Events.ApplyDeltas, response);
        if (response.multipleTabHeader && response.tabHeaderId) {
            this.event.publish(Events.ApplyMultipleTab, response.tabHeaderInfo);
        }
        this.processCallbacks(action, response);
    };
    ActionService.prototype.processCallbacks = function (action, response) {
        try {
            if (action.callback) {
                action.callback(response);
            }
        }
        finally {
            this.processPending();
        }
    };
    ActionService.prototype.processPending = function () {
        this.state = ActionState.Idle;
        if (this.pendingEvents.length > 0) {
            this.sendActions();
        }
    };
    ActionService.prototype.onException = function () {
        this.state = ActionState.Idle;
        this.processPending();
    };
    __decorate([
        ExceptionHandler('onException'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ActionService.prototype, "sendActions", null);
    return ActionService;
}());
export { ActionService };
